'use client';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiButton from '@new-components/atoms/MuiButton';
import MuiTypography from '@new-components/atoms/MuiTypography';
import NumericMultiCheckButton from '@new-components/atoms/NumericMultiCheckButton';
import {FilterPopup} from '@new-components/molecules/FilterPopup';
import React, {useMemo} from 'react';
import {HorizontalCheckInputProps} from '@new-components/atoms/NumericMultiCheckButton';

type Props = {
  title: string;
  subTitle: string;
  value: string[];
  handleChange: (arg: string[]) => void;
  options: HorizontalCheckInputProps['options'];
};
const BedroomPopupFilter = (props: Props) => {
  const filterValue = useMemo(() => {
    if (!props.value.length || props.value.includes('any')) {
      return 'Any';
    }

    const getExpectedValue = (value: string) => {
      return value === '1' ? `${value} Bedroom` : `${value} Bedrooms`;
    }

    return props.value
      .map((value) => (isNaN(Number(value)) ? value : getExpectedValue(value)))
      .join(', ');
  }, [props.value]);

  const handleReset = () => {
    props.handleChange([]);
  };

  return (
    <FilterPopup label='Bedrooms' value={filterValue}>
      <MuiBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <MuiTypography
          sx={{
            fontSize: '24px',
            fontWeight: 500,
            letterSpacing: '-0.4px',
            color: '#2D2D2D',
          }}>
          {props.title}
        </MuiTypography>
        <MuiButton
          variant='text'
          onClick={handleReset}
          sx={{
            'fontFamily': 'Poppins, sans-serif',
            'fontSize': '17px',
            'fontWeight': 400,
            'lineHeight': '23.8px',
            'textDecorationLine': 'underline',
            'color': '#2D2D2D',
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline',
            },
            '&:focus': {outline: 'none'},
          }}>
          Reset
        </MuiButton>
      </MuiBox>
      <MuiTypography
        sx={{
          height: '16px',
          fontSize: '13px',
          fontWeight: 400,
          letterSpacing: '-0.4px',
          color: '#82807EB2',
          marginBottom: '24px',
        }}>
        {props.subTitle}
      </MuiTypography>
      <NumericMultiCheckButton
        options={props.options}
        onSelectionChange={props.handleChange}
        checkedOptions={props.value}
      />
    </FilterPopup>
  );
};

export default BedroomPopupFilter;
